import React from 'react';
import { TestimonialsSection } from './TestimonialsSection';
const data = [{
  initials: 'CR',
  quote: 'El Token System cambió la dinámica de casa completamente. Mi hijo hace los ejercicios solo porque quiere ganar tokens. Nunca pensé que iba a funcionar tan rápido.',
  name: 'Cecilia R.',
  location: 'Mendoza',
  role: 'MegaPack + Master-Pack',
  highlight: 'MegaPack + Master-Pack'
}, {
  initials: 'RM',
  quote: 'Las Cartas de Conexión las uso al inicio de clase. En dos semanas el grupo habla de emociones como si siempre lo hubieran hecho. Es increíble.',
  name: 'Roberto M.',
  location: 'Buenos Aires',
  role: 'Docente de secundaria'
}, {
  initials: 'SC',
  quote: 'Mi hija de 15 completó el Tomo 1 sola en una semana. Después me pidió que lo hiciéramos juntas desde el principio. Lloramos juntas en varios ejercicios. Vale cada peso.',
  name: 'Sofía C.',
  location: 'Santiago',
  role: 'Mamá de dos adolescentes'
}, {
  initials: 'PA',
  quote: 'Lo recomiendo a todas las familias de mis pacientes adolescentes. Es el puente entre la consulta y el hogar que siempre necesité.',
  name: 'Pablo A.',
  location: 'Medellín',
  role: 'Psicólogo escolar'
}];
export function Testimonials2() {
  return <TestimonialsSection title="❤️ MÁS FAMILIAS Y DOCENTES QUE YA LO TIENEN" testimonials={data} darker data-id="element-275" />;
}